import { Cable, CableEnd } from '@bechtel/sr-types';
import { find, forEach, isNil } from 'lodash';
import { Mark, TerminationFeedbackFormikState } from './form/types';

export const terminationFeedbackInitialValues: TerminationFeedbackFormikState = {
  id: '',
  tag: '',
  commodityType: '',
  termConstStatus: '',
  termConnMade: 0,
  termCrimpTool: '',
  termInstalledBy: '',
  termInstalledTime: '',
  termInspectedBy: '',
  termInspectedTime: '',
  tagInvalid: false,
  marks: [],
};

export const getMarksData = (data: Cable) => {
  if (!data) return;

  // Transform cableMarks to Marks array
  const defaultMarkValue = 0.0;
  const marks: Mark[] = [];
  if (!data.cableMarks || data?.cableMarks?.length === 0) {
    // Create cable mark array size equal to the number of cables
    for (let i = 1; i <= data?.numberOfCables; i++) {
      marks.push({ sequenceNumber: i, fromMark: defaultMarkValue.toFixed(2), toMark: defaultMarkValue.toFixed(2) });
    }
  } else {
    forEach(data.cableMarks, (cableMark) => {
      const foundMark = find(marks, (mark: Mark) => mark.sequenceNumber === cableMark?.sequenceNumber);
      if (!foundMark) {
        const mark: Mark = {
          sequenceNumber: cableMark?.sequenceNumber as number,
          fromMark:
            cableMark?.cableEnd === CableEnd.FROM && !isNil(cableMark?.mark)
              ? cableMark?.mark.toFixed(2)
              : defaultMarkValue.toFixed(2),
          toMark:
            cableMark?.cableEnd === CableEnd.TO && !isNil(cableMark?.mark)
              ? cableMark.mark.toFixed(2)
              : defaultMarkValue.toFixed(2),
        };
        marks.push(mark);
      } else {
        foundMark.sequenceNumber = cableMark?.sequenceNumber as number;
        if (cableMark?.cableEnd === CableEnd.FROM) {
          foundMark.fromMark = !isNil(cableMark?.mark) ? cableMark?.mark.toFixed(2) : defaultMarkValue.toFixed(2);
        } else {
          foundMark.toMark = !isNil(cableMark?.mark) ? cableMark?.mark.toFixed(2) : defaultMarkValue.toFixed(2);
        }
      }
    });
  }
  return marks;
};
